import { render } from "./CustomerBonus.vue?vue&type=template&id=92920a02&scoped=true"
import script from "./CustomerBonus.vue?vue&type=script&lang=js"
export * from "./CustomerBonus.vue?vue&type=script&lang=js"

import "./CustomerBonus.vue?vue&type=style&index=0&id=92920a02&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92920a02"]])

export default __exports__